import type { SelectorObject } from '../types';

export const fixedChargesMenuItemsSelectors = {
  oneTimeFee: 'fixed-charges-menu-items-one-time-fee',
  subscriptionFee: 'fixed-charges-menu-items-subscription-fee',
} satisfies SelectorObject<'fixed-charges-menu-items-'>;